import { withStaticProperties } from '@tamagui/core';

import { Actions, DialogActionsProps } from './Actions';
import { Content, DialogContentProps } from './Content';
import { Dialog as DialogFrame, DialogProps } from './Dialog';

const Dialog = withStaticProperties(DialogFrame, {
  Content,
  Actions,
});

export { Dialog };
export type { DialogProps, DialogContentProps, DialogActionsProps };
